/*
Ashraf 11/28/2022 2698948956 search repo fields table
Poornima 11/30/2022 2698948956 prepopulated category field in map fields
Poornima 11/30/2022 2698948956 fixed prepopulate bugs
Suresh Peddavoora 12/01/2022 2698948956 Fixed Text Field Disabled Color Issues
Suresh Peddavoora 12/01/2022 2698948956 Changed Text Field Variant from outlined to Standard
Ashraf 12/01/2022 2698948956 Added field type in search
Sai Maheshwar 12/04/2022 2698948956 Added map fields save close buttons
Sai Maheshwar 12/04/2022 2698948956 fixed fields prepopulation issue
Ashraf 12/04/2022 2698948956 fixed prepopulation issue
Ashraf 12/04/2022 2698948956 changed button styles
Prakash 12/05/2022 2698948956 Fixed Buttons and Fields Alignments.
Raghu 12/06/2022 2698948956 Buttons styling fixes
Suresh peddavoora 12/21/2022 2698948956 Fixed text fields alignments for responsive
Raghu 12/29/2022 2698948956 Field Alignment Fixes
suresh peddavoora 02/24/2023 2698948956 New UI changes
suresh peddavoora 02/27/2023 2698948956 New UI changes
suresh peddavoora 03/15/2023 2698948956 New UI changes for responsive
Prakash 06/04/2023 2698948956 fixed alignments issue in responsive
Sohel 04/27/2023 4136387705 Added Data Calculation Field
Sohel 10/03/2023 5155351299 Added Field Description and Field Company Fields
Sohel 06/10/2023 5155351299 added dropdown exisitng value for repo name
Sohel 10/07/2023 5155351299 existing repo name search dropdown bug fix
Sohel 10/10/2023 5155351299 Fixed Suggestion Select Issue
Sohel 10/10/2023 2805568664 Add field based on repository name and field name
*/

import React, {useEffect, useState, useContext, useRef} from 'react';
import {Form, Formik} from 'formik';
import {Button, Checkbox, FormHelperText, Grid, TextField, MenuItem} from '@material-ui/core';
import {ThemeContext} from '../../../themes/ThemeProvider';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';
import SearchFieldsTable from './SearchFieldsTable';
import {useDispatch, useSelector} from 'react-redux';
import {
  getBaseCategory,
  getFieldType,
} from '../../../redux/reducers/GlobalField/AddFieldList';
import GuiAutoComplete from '../../FormComponents/GuiAutoComplete';
import GuiTextField from '../../FormComponents/GuiTextField';
import {filteredCheckedData, tempSelectFunc} from '../../../util/Functions';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import {createdByOptions} from '../../../util/CreatedByForOptions';
import {fetchCreatedByDropDownData} from '../../../redux/reducers/ReportMaster';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {fetchExistingDataRepositoryNames} from '../../../redux/reducers/GlobalField/DataRepository';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const SearchDataRepositoryFields = ({
  selectedRows,
  setSelectedRows,
  handleClose,
  formValues,
  baseValue,
  tempSelectedRows,
  setTempSelectedRows,
  mapFields,
  refValues,
  setCustomWindowFieldValue,
  deletedRules,
  setDeletedRules,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [nameData, setNameData] = useState();
  const [namePopover, setNamePopover] = useState(false);
  const {
    allRepositoryNames,
  } = useSelector(({dataRepository}) => dataRepository);
  useEffect(() => {
    dispatch(getFieldType());
  }, []);

  const {baseCategoryData, fieldTypeData} = useSelector(
    ({addFieldList}) => addFieldList,
  );
  const {createdByData} = useSelector(({reportMaster}) => reportMaster);
  const companyData = JSON.parse(sessionStorage.getItem('companyName'));
  companyData.unshift('ALL');

  const [searchData, setSearchData] = useState({
    category: formValues?.category || '',
  });
  const dispatch = useDispatch();
  const [submit, setSubmit] = useState(false);
  const tempUnCheckedRef = useRef([]);

  useEffect(() => {
    dispatch(getBaseCategory());
    dispatch(fetchCreatedByDropDownData('datarepository'));
    dispatch(fetchExistingDataRepositoryNames());
  }, []);

  const initialValues = {
    category: baseValue,
    fieldName: '',
    repoName: '',
    fieldType: '',
    repoDescription: '',
    fieldDescription: '',
    company: companyData,
    createdBy: '',
    createdDate: null,
  };

  const filteredCategory = baseCategoryData?.filter((item) => item?.categoryCode !== 'AR');

  useEffect(() => {
    setSearchData({...searchData, category: baseValue});
    setSubmit(true);
  }, [baseValue]);

  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };

  const getWindowNameData = () => {
    if (allRepositoryNames && allRepositoryNames?.length > 0) {
      return allRepositoryNames?.filter(
        (i) =>
          String(i?.repositoryName?.toLowerCase())?.startsWith(nameData?.toLowerCase()) &&
            i?.isActive === 'Y',
      );
    } else {
      return [];
    }
  };

  window.onclick = function() {
    setNamePopover(false);
  };
  // const tempSelectFunc = (key1, key2) => {
  //   const obj = {};
  //   tempUnCheckedRef.current.forEach((el) => {
  //     if (key1 && key2) {
  //       if (!obj[el[key1] + el[key2]]) {
  //         obj[el[key1] + el[key2]] = el;
  //       }
  //     } else {
  //       if (!obj[el[key1]]) {
  //         obj[el[key1]] = el;
  //       }
  //     }
  //   });
  //   return obj;
  // };

  // const filteredCheckedData = (orgArr, compareObj, key1, key2) => {
  //   let newSelectedRows = [];
  //   let newUnSelectedRows = [];
  //   if (key1 && key2) {
  //     newSelectedRows = orgArr.filter((el) => {
  //       if (compareObj[el[key1] + el[key2]]) {
  //         newUnSelectedRows.push(el);
  //         return false;
  //       } else {
  //         return true;
  //       }
  //     });
  //   } else {
  //     newSelectedRows = orgArr.filter((el) => {
  //       if (compareObj[el[key1]]) {
  //         return false;
  //       } else {
  //         return true;
  //       }
  //     });
  //   }

  //   return [newSelectedRows, newUnSelectedRows];
  // };

  // reset data and set initial data(2700807425)
  const onClear = () => {
    const data = {
      category: baseValue,
      fieldName: '',
      repoName: '',
      fieldType: '',
      repoDescription: '',
      createdDate: null,
      createdBy: '',
      fieldDescription: '',
      company: companyData,

    };
    setSearchData(data);
  };
  return (
    <div className={classes.dialoguecardStyles}>
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              errors,
            } = props;
            return (
              <div>
                <Form autoComplete="off" noValidate>
                  <div className="standard-field-textfields new-standard-textfields">
                    <ErrorBoundaryForComponents>
                      <Grid container spacing={2} className="align-items-center">
                        <Grid item xs={2} md={4} lg={3} className="form-group autocomplete-field">
                          <GuiAutoComplete
                            name="category"
                            id="category"
                            size="small"
                            value={values.category}
                            disabled={baseValue}
                            required
                            options={filteredCategory}
                            getOptionLabel={(option) => {
                              return option && option.categoryName ?
                                option.categoryCode === null ?
                                  option.categoryName :
                                  option.categoryCode + ' - ' + option.categoryName :
                                '';
                            }}
                            onChange={(e, value) => {
                              // When Category value change reset Group Code dropdown data and set Group Code as empty.
                              // dispatch(resetGroupData());
                              setFieldValue('groupCode', '');
                              if (value) {
                                setFieldValue('category', value);
                                //   setBaseValue(value);
                              } else {
                                setFieldValue('category', '');
                                //   setBaseValue("");
                                //   dispatch(resetGroupData());
                              }
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  error={touched.category && errors.category}
                                  margin="dense"
                                  variant="outlined"
                                  label="Category"
                                  placeholder="Select Category"
                                />
                              </div>
                            )}
                          />
                        </Grid>
                        <Grid item xs={6} md={4} lg={3} className="form-group">
                          <TextField
                            margin="dense"
                            className={` ${classes.labelName}`}
                            placeholder={`Enter Repository Name`}
                            label="Repository Name"
                            name="repoName"
                            value={values?.repoName}
                            onChange={(e) => {
                              setFieldValue('repoName', e.target.value);
                              if (e.target.value) {
                                setNamePopover(true);
                                setNameData(e?.target?.value);
                              } else if (e.target.value === '') {
                                setNamePopover(false);
                              }
                            }}
                            onBlur={handleBlur}
                            fullWidth
                            variant="outlined"
                            touched={touched.repoName}
                            error={Boolean(touched.repoName && errors.repoName)}
                          />
                          <FormHelperText>
                            {touched.repoName && errors.repoName && errors.repoName}
                          </FormHelperText>
                          <Grid className="windowcode-popover Add-trigger-group-popover">
                            {namePopover &&
                              getWindowNameData()?.map((data, i) => (
                                <MenuItem key={i} onClick={()=>{
                                  setFieldValue('repoName', data?.repositoryName);
                                }}>{data?.repositoryName}</MenuItem>
                              ))}
                          </Grid>
                        </Grid>
                        <Grid item xs={6} md={4} lg={3} className="form-group">
                          <TextField
                            margin="dense"
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            placeholder={`Enter Repository Description`}
                            label="Repository Description"
                            name="repoDescription"
                            value={values?.repoDescription}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.repoDescription}
                            error={Boolean(touched.repoDescription && errors.repoDescription)}
                          />
                          <FormHelperText>
                            {touched.repoDescription &&
                              errors.repoDescription &&
                              errors.repoDescription}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={6} md={4} lg={3} className="form-group">
                          <TextField
                            margin="dense"
                            placeholder={`Enter Field Name`}
                            label="Field Name"
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            name="fieldName"
                            value={values.fieldName}
                            onChange={(e) => {
                              setFieldValue('fieldName', e?.target?.value);
                            }}
                            onBlur={handleBlur}
                            fullWidth
                          />
                          <FormHelperText>
                            {touched.repoDescription &&
                              errors.repoDescription &&
                              errors.repoDescription}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={6} md={4} lg={3} className="form-group">
                          <TextField
                            margin="dense"
                            // className={`${classes.labelName} ${classes.inputLabel}`}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            placeholder={`Enter Field Description`}
                            label="Field Description"
                            name="fieldDescription"
                            value={values?.fieldDescription}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.fieldDescription}
                          />
                        </Grid>
                        <Grid item xs={6} md={4} lg={3} className="form-group autocomplete-field">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="fieldType"
                            id="fieldType"
                            size="small"
                            value={values.fieldType}
                            options={fieldTypeData || []}
                            // getOptionDisabled={(option) => option.categoryCode === ""}
                            getOptionLabel={(option) => {
                              return option ? option : '';
                            }}
                            onChange={(e, value) => {
                              setFieldValue('fieldType', value);
                            }}
                            placeholder="Select Field Type"
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  variant="outlined"
                                  margin="dense"
                                  name="fieldType"
                                  label="Field Type"
                                  placeholder="Select Field Type"
                                />
                              </div>
                            )}
                          />
                        </Grid>
                        <Grid item xs={6} md={4} lg={3} className="form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="createdBy"
                            id="createdBy"
                            size="small"
                            value={values.createdBy}
                            options={createdByData || []}
                            autoHighlight
                            getOptionLabel={(option) => {
                              return option && option?.userLoginName ? option?.userLoginName : '';
                            }}
                            renderOption={(option) => {
                              return createdByOptions(option);
                            }}
                            onChange={(e, value) => {
                              setFieldValue('createdBy', value);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  variant="outlined"
                                  margin="dense"
                                  label="Created By"
                                  placeholder="Select Created By"
                                />
                              </div>
                            )}
                          />
                        </Grid>
                        <Grid item xs={6} md={4} lg={3} className="form-group">
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              // className={` ${classes.labelName}`}
                              className={` ${classes.labelName}`}
                              format="MM/dd/yyyy"
                              placeholder="MM/DD/YYYY"
                              fullWidth
                              value={values.createdDate}
                              name="createdDate"
                              onBlur={handleBlur}
                              inputVariant="outlined"
                              helperText=""
                              label="Date Created"
                              onChange={(val) => {
                                setFieldValue('createdDate', val);
                              }}
                              autoOk
                              margin="dense"
                              touched={touched?.createdDate}
                              error={Boolean(touched?.createdDate && errors?.createdDate)}
                            />
                          </MuiPickersUtilsProvider>
                          <FormHelperText variant="outlined">
                            {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={6} md={4} lg={3} className="form-group">
                          <GuiAutoComplete
                            name={'company'}
                            id={'company'}
                            size="small"
                            limitTags={1}
                            classes={{
                              option: classes.option,
                              listbox: classes.listBox,
                            }}
                            disableCloseOnSelect
                            getOptionSelected={(option, value) => option === value}
                            value={values?.company?.length > 0 ? values?.company : []}
                            multiple
                            onChange={(e, value) => {
                              setFieldValue('company', value);
                            }}
                            options={companyData}
                            autoHighlight
                            renderOption={(option, {selected}) => {
                              return (
                                <React.Fragment>
                                  <>
                                    <Checkbox
                                      icon={icon}
                                      checkedIcon={
                                        <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                      }
                                      checked={selected}
                                    />
                                  </>
                                  {option ? option : ''}
                                </React.Fragment>
                              );
                            }}
                            getOptionLabel={(option) => {
                              return option ? option : '';
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  variant="outlined"
                                  className={` autocomplete-multiselect-label ${classes.labelName}`}
                                  margin="dense"
                                  touched={touched}
                                  error={touched?.company && errors?.company}
                                  label={'Company'}
                                  placeholder={`Select Company`}
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'off', // disable autocomplete and autofill
                                  }}
                                />
                              </div>
                            )}
                          />
                        </Grid>
                        <Grid item xs={6} md={6} lg={3} className="form-group">
                          <div className="d-flex justify-content-end justify-content-lg-start">
                            <Button
                              variant="outlined"
                              className={`reset-btn mr-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                handleReset();
                                setSubmit(true);
                                onClear();
                                setSearchData(initialValues);
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              variant="outlined"
                              type="submit"
                              className={`search-btn ml-1 ${classes.buttonRoot}`}
                            >
                              Search
                            </Button>
                          </div>
                        </Grid>
                        {mapFields ? (
                          <Grid className="form-group" item md={6} lg={5}>
                            <div className="d-flex justify-content-lg-start justify-content-md-end">
                              <Button
                                aria-label="close"
                                variant="outlined"
                                className={` mr-1 reset-btn ${classes.buttonRoot}`}
                                onClick={() => {
                                  handleClose();
                                }}
                              >
                                Close
                              </Button>
                              <Button
                                aria-label="save"
                                variant="outlined"
                                className={`search-btn ml-1 ${classes.buttonRoot}`}
                                onClick={() => {
                                  const obj = tempSelectFunc(
                                    'fieldName',
                                    'repositoryName',
                                    tempUnCheckedRef,
                                  );

                                  if (setSelectedRows) {
                                    const [newSelectedRows, newUnSelectedRows] =
                                      filteredCheckedData(
                                        selectedRows,
                                        obj,
                                        'fieldName',
                                        'repositoryName',
                                      );
                                    // newSelectedRows?.map((i) => {
                                    //   i["viewOnly"] = refValues["viewOnlyField" + i.fieldName]  || i?.viewOnly;
                                    //   i["isMandatory"] = refValues["mandatoryField" + i.fieldName]  || i?.isMandatory;
                                    //   i["fieldLabel"] = refValues["fieldHeader" + i.fieldName]  || i?.fieldLabel;
                                    // });
                                    tempSelectedRows?.forEach((r) => {
                                      // let fH = refValues["fieldHeader" + r.fieldName] ||  r.fieldLabel;
                                      // let mF = refValues["mandatoryField" + r.fieldName]  || r?.isMandatory;
                                      // let vF = refValues["viewOnlyField" + r.fieldName]  || r?.viewOnly;
                                      setCustomWindowFieldValue(
                                        'fieldHeader' + r.repositoryName + r.fieldName,
                                        r.fieldLabel,
                                      );
                                      setCustomWindowFieldValue(
                                        'mandatoryField' + r.repositoryName + r.fieldName,
                                        r?.isMandatory,
                                      );
                                      setCustomWindowFieldValue(
                                        'viewOnlyField' + r.repositoryName + r.fieldName,
                                        r?.viewOnly,
                                      );
                                    });
                                    const allSelectedRows = [
                                      ...newSelectedRows,
                                      ...tempSelectedRows,
                                    ];
                                    if (newUnSelectedRows.length > 0) {
                                      const allDeleteIds = [];
                                      newUnSelectedRows.forEach((el) => {
                                        if (el.fieldId) {
                                          allDeleteIds.push(el.fieldId);
                                        }
                                      });

                                      const ids = [...deletedRules, ...allDeleteIds];
                                      setDeletedRules(ids);
                                    }

                                    setSelectedRows(allSelectedRows);
                                  }

                                  setTempSelectedRows([]);
                                  handleClose();
                                }}
                              >
                                Save
                              </Button>
                            </div>
                          </Grid>
                        ) : null}
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
      </div>
      <SearchFieldsTable
        searchData={searchData}
        baseValue={baseValue}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        submit={submit}
        setSubmit={setSubmit}
        tempSelectedRows={tempSelectedRows}
        setTempSelectedRows={setTempSelectedRows}
        tempUnCheckedRef={tempUnCheckedRef}
      />
      {/* <div className="d-flex justify-content-center align-items-center mt-3">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn ml-1 ${classes.buttonRoot}`}
          onClick={() => handleClose()}
        >
          {"Save & Close"}
        </Button>
      </div> */}
    </div>
  );
};

export default React.memo(SearchDataRepositoryFields);
